export default __webpack_public_path__ + "static/media/G_D_btn__Dashboard.9e4c778b.svg";